import { Box, Grid, Typography } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';
import { useGlobalization } from '@Translations';

const TRENCH_BUFFER_FT = 7.5;
const TRENCH_BUFFER_M = 2.286;
const MERGE_BUFFER_FT = 5;
const MERGE_BUFFER_M = 1.524;

interface CalculationInfoProps {
	system: 'Metric' | 'Imperial';
}

export const CalculationInfo = ({ system }: CalculationInfoProps) => {
	const { t } = useGlobalization();
	return (
		<Grid container xs={12} item>
			<Grid item xs={1}>
				<Box sx={{ color: 'text.secondary' }}>
					<InfoOutlined />
				</Box>
			</Grid>
			<Grid item xs={11}>
				<Typography variant="subtitle2" color="textSecondary">
					{t('Rehab length calculation')}
				</Typography>
				<Typography variant="body2" color="textSecondary">
					{t(
						'Cost will be calculated based on the length of pipe sections with selected defects, not the full pipe length',
					)}
				</Typography>
				<Typography variant="caption" color="textSecondary">
					{t(
						'Trench buffer ({{trenchBuffer}}{{unit}}) and merge buffer ({{mergeBuffer}}{{unit}}) are applied automatically',
						{
							trenchBuffer:
								system === 'Imperial'
									? TRENCH_BUFFER_FT
									: TRENCH_BUFFER_M,
							mergeBuffer:
								system === 'Imperial'
									? MERGE_BUFFER_FT
									: MERGE_BUFFER_M,
							unit: system === 'Imperial' ? 'ft' : 'm',
						},
					)}
				</Typography>
			</Grid>
		</Grid>
	);
};
